import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import type { Qualification } from '../../../../types/qualification'

const resource = 'qualifications'

export const requests = {
  fetchQualifications: (q: string) => {
    return axiosForGigbaseBiz.get<DataResponse<Qualification[]>>(resource, {
      params: {
        q,
      },
    })
  },
}
